<template>
  <div class="create-active">
    <div class="msg">
      <div class="title">
        <p><span>*</span>大标题</p>
        <el-input
          placeholder="请输入内容"
          v-model="texts.title"
          clearable
        ></el-input>
      </div>
      <div class="meet-type">
        <p><span>*</span>会议类型</p>
        <el-autocomplete
          class="inline-input"
          v-model="texts.meetClass"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
        ></el-autocomplete>
      </div>
      <div class="meet-theme">
        <p><span>*</span>会议主题</p>
        <el-input
          placeholder="请输入内容"
          v-model="texts.theme"
          clearable
        ></el-input>
      </div>
      <div class="meet-time">
        <p><span>*</span>会议时间</p>
        <el-date-picker
          v-model="texts.time"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy年MM月dd日 H时mm分"
          @change="timeChange"
        ></el-date-picker>
      </div>
      <div class="meet-body" v-if="!editStatus && editStatus != 1">
        <p><span>*</span>参会人员</p>
        <el-select
          v-model="texts.bodys"
          multiple
          placeholder="请选择"
          @change="go"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="meet-adress">
        <p><span>*</span>会议地点</p>
        <el-input
          placeholder="请输入会议地点"
          v-model="texts.adress"
          clearable
        ></el-input>
      </div>
      <div class="meet-msg">
        <p><span>*</span>会议内容</p>
        <Uedior :content="memo" @changeHtml="changeHtml" style="width:70%"></Uedior>
      </div>
      <div class="submit">
        <input type="button" value="立即提交" @click="submit" id="input0" />
        <!-- <button ></button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Uedior from '@/views/component/Uedior'

import { updateActivityData, confirmUpdateActi } from '@/api/partyHomeApi'

import { standTimeHandle } from '@/utils/timeHandle'

export default {
  data() {
    return {
      texts: {
        title: '三会一课',
        meetClass: '',
        theme: '',
        time: '',
        adress: '',
        msg: '',
        bodys: [],
      },
      options: [
        {
          value: 'ALL_SELECT',
          label: '全选',
        },
      ],
      meetClassValue: [
        { value: '党小组会' },
        { value: '支委会' },
        { value: '党员大会' },
        { value: '党课' },
      ],
      checked: false,
      _choose: [],
      tempBodys: [],
      ActiTitle: '',
      id: 0,
      editStatus: 0,
      memo: '',
      token: '',
      initialTitle: '',
      initialCreatetime: ''
    }
  },
  created() {
    this.token = sessionStorage.getItem('token')
    this.ActiTitle = this.$route.query.ActiTitle
    this.id = this.$route.query.id
    this.editStatus = this.$route.query.editStatus
    if (this.editStatus == 1) {
      this.getUpdateActivityData()
    }
  },
  methods: {
    getUpdateActivityData() {
      const params = {
        tittle: sessionStorage.getItem('token'),
        title: this.ActiTitle,
        id: this.id,
      }
      updateActivityData(params).then((res) => {
        console.log('update res: ', res)
        this.texts.title = res.msg.tittle
        this.texts.meetClass = res.msg.typename
        this.texts.theme = res.msg.title
        this.texts.time = this.handleTime(res.msg.time)
        this.texts.adress = res.msg.address
        this.memo = res.msg.memo
        this.initialTitle = res.msg.title
        this.initialCreatetime = res.msg.createtime
      })
    },
    handleTime(time) {
      const timeArr = time.split('T')
      console.log('timeArr: ', timeArr)
      return timeArr[1] ? timeArr[0] + ' ' + timeArr[1].substring(0, 8) : time
    },
    go(event) {
      //全选事件,使用了一个变量用来保存上一次选择的数据来进行判断
      if (this._choose != undefined && this._choose.includes('ALL_SELECT')) {
        if (!event.includes('ALL_SELECT')) remove(event, this.options)
      }
      if (event[event.length - 1] == 'ALL_SELECT') add(event, this.options)
      function add(event, array) {
        array.filter((item, index) => {
          if (!event.includes(item.value)) {
            event.push(item.value)
          }
        })
      }
      function remove(event, array) {
        for (let x = event.length; x >= 0; x--) {
          event.splice(event[x])
        }
      }
      this._choose = event
    },
    timeChange(time) {
      console.log(time)
      this.texts.time = standTimeHandle(time)
    },
    changeHtml(html) {
      this.memo = html
    },
    submit() {
      // console.log(this.texts.msg);
      if (this.editStatus && this.editStatus == 1) {
        const params = {
          title: this.texts.theme,
          address: this.texts.adress,
          time: this.texts.time,
          memo: this.memo,
          town: this.token,
          typename: this.texts.meetClass,
          township: this.initialTitle,
          PreferredDate: this.initialCreatetime
        }
        for (let key in params) {
          if (params[key] == '') {
            this.$message ({
              message: '请填写完整',
              type: 'warning',
              duration: 1500
            })
            return false
          }
        }
        console.log(params)
        confirmUpdateActi(params).then(res => {
          console.log('update res: ', res)
          if (res.code == 0) {
            this.$message ({
              message: '修改成功',
              type: 'success',
              duration: 1500
            })
            setTimeout(() => {
              this.$router.go(-1)
            }, 1500)
          } else {
            this.$message ({
              message: res.msg,
              type: 'warning',
            })
          }
        })
      } else {
        let array = Object.keys(this.texts)
        let goOn = true
        array.some((item) => {
          if (this.texts[item] == '') {
            // console.log(item);
            alert('请填写完整')
            goOn = false
            return true
          }
        })
        if (goOn) {
          this.axios
            .post('/api/Party/AddActivity', {
              tittle: this.texts.title,
              typename: this.texts.meetClass,
              title: this.texts.theme,
              address: this.texts.adress,
              time: this.texts.time,
              remark: `${this.tempBodys}`,
              memo: this.texts.msg,
              town: sessionStorage.getItem('token'),
            })
            .then((e) => {
              console.log(e.data)
              if (e.data.code == 0) {
                alert('添加成功')
                this.$router.go(-1)
              }
            })
            .catch((err) => {
              console.log('err', err)
            })
        }
      }
    },
    querySearch(queryString, cb) {
      // debugger
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    getMsg() {
      this.axios
        .post('/api/Party/GetUser', {
          c1loginname: sessionStorage.getItem('token'),
        })
        .then((e) => {
          console.log(e.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getPeople() {
      this.axios
        .post('/api/Party/GetUser', {
          c1loginname: sessionStorage.getItem('token'),
        })
        .then((e) => {
          console.log(e.data)
          switch (e.data.code) {
            case 0:
              e.data.msg.filter((item) => {
                this.options.push({ value: item.c2name, lable: item.c2userid })
              })

              // console.log(this.options);

              break

            default:
              break
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    returnContent() {
      this.dat.content = this.$refs.ue.getUEContent()
      console.log(this.dat.content)
    },
    traverse(item) {
      // console.log(item);
      function name(p) {
        return p.value == item
      }
      return this.options.findIndex(name)
    },
    delectTraverse(params) {
      params.filter((item, index) => {
        // console.log(item);
        function name(p) {
          return p.lable == item
        }

        let tempNum = this.options.findIndex(name)
        let nameTemp = this.options[tempNum].value
        // console.log(this.texts.bodys.includes(nameTemp));

        if (!this.texts.bodys.includes(nameTemp)) {
          this.tempBodys.splice(index, 1)
        }
      })
    },
  },
  mounted() {
    this.getMsg()
    this.restaurants = this.meetClassValue
    this.getPeople()
  },
  components: {
    Uedior,
  },
  computed: {
    look: function() {
      // let tempArr = []
      this.texts.bodys.forEach((item, index) => {
        // console.log(item);
        if (typeof item == 'string') {
          let num = this.traverse(item)
          this.tempBodys[index] = this.options[num].lable
        }
      })
      if (this.texts.bodys.length < this.tempBodys.length) {
        this.delectTraverse(this.tempBodys)
      }
      console.log('computed', this.tempBodys)
    },
  },
  watch: {
    look: function() {
      // console.log('watch',this.texts.bodys);
    },
  },
}
</script>

<style lang="scss" scoped>
.create-active {
  .msg {
    .submit {
      input[type='button'] {
        width: 3.8rem;
        height: 0.8rem;
        background-image: linear-gradient(-70deg, #f9b94d 0%, #fdcb76 100%);
        box-shadow: 0px 0.06rem 0.12rem 0px rgba(249, 185, 77, 0.4);
        border-radius: 0.08rem;
        border: 0;
        color: #fff;
        font-size: 0.3rem;
      }
      text-align: center;
      margin-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .meet-msg,
    .meet-adress,
    .meet-body,
    .meet-time,
    .meet-theme,
    .meet-type,
    .title {
      .el-select,
      .el-textarea,
      .el-input {
        width: 70%;
      }
      p {
        width: 30%;
        // text-align: center;
      }
      span {
        color: red;
      }
      display: flex;
      align-items: center;
      width: 90%;
      margin: 0 auto;
      padding-top: 0.3rem;
    }
  }
  .el-autocomplete {
    width: 70%;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>

<style lang="scss">
.create-active {
  .w-e-menu {
    z-index: 8 !important;
  }
  .w-e-text-container {
    z-index: 8 !important;
  }
}
</style>
